import styled from "styled-components";
import { Container } from "../common/container";
import { breakpoints } from "../constants/breakpoints";

export const ContactUsContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  @media ${breakpoints.tablet} {
    width: 100%;
  }
`;

export const ContactUsTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-weight: bold;
  line-height: 1.25;
  margin: 0 0 8px 0;
  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["5xl"]};
  }
`;

export const ContactUsDesc = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.black};
  font-weight: bold;
  line-height: 1.25;
  margin: 0;

  a {
    color: ${({ theme }) => theme.colors.brand["500"]};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }
`;

export const ContactUsHeaderSection = styled.section`
  padding: 50px 0;
`;

export const ContactUsLocationContainer = styled.section``;

export const ContactUsLocationTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
  color: ${({ theme }) => theme.colors.brand["500"]};
  font-weight: bold;
  line-height: 1.25;
`;

export const ContactUsLocationWrapper = styled.ul`
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
`;

export const ContactUsLocationItem = styled.li<{ isSelected?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  border: 2px solid
    ${({ isSelected, theme }) =>
      isSelected ? theme.colors.brand["500"] : theme.colors.neutral["500"]};
  padding: 16px 24px;
  border-radius: 6px;
  line-height: 1;
  background: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.brand["100"] : "none"};
  color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.brand["500"] : theme.colors.black};
  cursor: pointer;
`;

export const ContactUsAddressContainer = styled.div`
  margin: 60px 0 0 0;
`;

export const ContactUsAddressName = styled.h3`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["2xl"]};
`;

export const ContactUsAddressDesc = styled.p`
  color: ${({ theme }) => theme.colors.neutral["600"]};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  font-weight: bold;
`;

export const ContactUsAddress = styled.div``;

export const ContactUsAddressImage = styled.figure`
  margin: 32px 0;
  border-radius: 24px;
  overflow: hidden;
  cursor: pointer;
`;
